export const IgnoredEventTypes = ['ASYNC_REQUEST_COMPLETED'];
